import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class CostInfo {
  // 成本信息列表
  static getCostInfoList(option) {
    let url = '/oa/api/other/fee/type/list?'
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改成本信息
  static postModCostInfo(data) {
    let url = '/oa/api/other/fee/type/modify'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 导入
  static postExcel(data) {
    const url = '/oa/api/upload/other/fee'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default CostInfo